/**
 * URL Encode Tool
 */

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import type { ITransformerTool } from '@/interfaces/ITool';

export const UrlEncodeTool: ITransformerTool = {
  id: 'url-encode',
  name: 'URL Encode',
  description: 'Encode text for use in URLs',
  version: '1.0.0',
  type: 'transformer',
  category: 'Encoders & Decoders',
  keywords: ['url', 'encode', 'percent', 'uri', 'encoding'],

  seo: {
    slug: 'url-encode',
    pageTitle: 'URL Encoder - Free Online Percent-Encoding Tool',
    metaDescription: 'Encode text for safe use in URLs with percent-encoding. Handles special characters and Unicode. Fast, private, runs entirely in your browser.',
    keywords: ['url encode', 'url encoder', 'percent encoding', 'uri encode online'],
    relatedTools: ['url-decode', 'base64-encode'],
    schemaType: 'WebApplication',
  },

  supportedInputTypes: [SEMANTIC_TYPES.TEXT],
  outputType: SEMANTIC_TYPES.URL_ENCODED,

  attributes: [
    {
      name: 'encodeAll',
      type: 'boolean',
      label: 'Encode All Characters',
      defaultValue: false,
      description: 'Encode all non-alphanumeric characters (including - _ . ~)',
    },
  ],

  async transform(input: string, config: Record<string, unknown>): Promise<string> {
    if (config.encodeAll) {
      // Encode everything except alphanumeric
      const encoder = new TextEncoder();
      return [...input].map(char => {
        if (/[A-Za-z0-9]/.test(char)) {
          return char;
        }
        const bytes = encoder.encode(char);
        return Array.from(bytes).map(b => '%' + b.toString(16).toUpperCase().padStart(2, '0')).join('');
      }).join('');
    }
    
    return encodeURIComponent(input);
  },
};

